import { Grid } from '@material-ui/core';
import DrillxReactSelect from 'components/DrillxReactSelect';
import { mapTimezoneLabelToValue, timezones } from 'constants/timezone';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { updateCurrentTimezone } from 'redux/Wells';
import { useSelectCurrentTimezone } from 'redux/Wells/selectors';

import styles from '../../ProfilePopup.module.scss';

type OptionType = {
  label: string;
  value: string;
};

type ValueType<OptionType> = OptionType | null | undefined;

const TimezoneSelect: FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentTimezone: number = useSelectCurrentTimezone();

  const getTimezoneChoice = (timezone: number): OptionType => ({
    value: timezone.toString(),
    label: mapTimezoneLabelToValue[timezone],
  });

  const onTimezoneChange = (selectedOption: ValueType<OptionType>) => {
    dispatch(updateCurrentTimezone(parseInt((selectedOption as OptionType).value, 10)));
  };

  return (
    <Grid className={styles.selector}>
      <span className={styles.selectorTitle}>
        {intl.formatMessage({ id: 'header.profile.timeZone' })}
      </span>
      <DrillxReactSelect
        className={styles.timeZoneSelector}
        value={getTimezoneChoice(currentTimezone)}
        options={Object.values(timezones).map(timezone => getTimezoneChoice(timezone))}
        isSearchable={false}
        onChange={(selectedOption: any) => onTimezoneChange(selectedOption)}
        isLoading={false}
      />
    </Grid>
  );
};

export default TimezoneSelect;
